// extracted by mini-css-extract-plugin
export default {"productGallery":"WJ-z","inQuickShop":"XJ-z"};